import * as React from 'react';
import {useEffect, useState} from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography
} from '@material-ui/core';
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import {TextBar} from 'src/components/sub-components/TextBar';
import {SearchBar} from 'src/components/sub-components/SearchBar';
import {addButtonColor, mainAccordingColor} from 'src/components/sub-components/colors/colors';
import {AddNewRoleAccordingList} from './according-list/AddNewRoleAccordingList';
import {environment} from 'src/environments/environment';
import {AlertBar} from 'src/components/sub-components/AlertBar';

export function AddNewRole(props) {
  const classes = useStyles()
  const [hidden, setHidden] = useState(false)
  const [allPrivileges, setAllPrivileges] = useState([])
  const [allActions, setAllActions] = useState([])
  const [currentPrivileges, setCurrentPrivileges] = useState([])
  const [search, setSearch] = useState("")
  const [parentSelect, setParentSelect] = useState([])
  const [isSelectActions, setIsSelectActions] = useState(false)
  const [actions, setActions] = useState([])
  const [selectAll, setSelectAll] = useState([])

  const [idError, setIdError] = useState({error: false, errorMsg: ""})
  const [nameError, setNameError] = useState({error: false, errorMsg: ""})

  const [selectedName, setSelectedName] = useState()
  const [selectedId, setSelectedId] = useState()
  const [selectedDescription, setSelectedDescription] = useState()

  //alert states
  const [alertOpen, setAlertOpen] = useState(false)
  const [severity, setSeverity] = useState("success")
  const [topic, setTopic] = useState("")
  const [message, setMessage] = useState("")
  const [hiddenPrivilege, setHiddenPrivilege] = useState(true)
  const [isSelectAllPrivileges, setIsSelectAllPrivileges] = useState(false)
  const [count, setCount] = useState(0)

  //loading state
  const [loading, setLoading] = useState(false)

  const [show, setShow] = useState(-1)
  const openEdit = (i) => {
    if (i === show) {
      setShow(-1)
    } else {
      setShow(i)
    }
  }

  //getAll privileges function
  let newAllPrivilege = []
  let allNewPrivileges = []
  const getPrivileges = () => {
    setLoading(true)
    fetch(`${environment.host}/ums/super/user-privileges`,
      {
        method: "GET",
        headers: {'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {

          let actions = []
          data.content.map((privilege) => {
            if (privilege.actions && Array.isArray(privilege.actions)) {
              privilege.actions.map((action) => {
                if (!actions.includes(action.action_name)) {
                  actions.push(action.action_name)
                }
              })
            }

            if (privilege.child.length == 0) {
              privilege.child.map(c => {
                if (c.actions) {
                  c.actions.map(a => a.selected = null)
                }
              })
            }
            pushAllActions(privilege.child, actions)
          })
          setAllActions(actions);

          data.content.map(p => {
            p.selected = false
            if (p.actions) {
              p.actions.map(a => a.selected = false)
            }
            allNewPrivileges.push(p)
            idFinder(p, data.content)
          })
          ids.map(p => {
            if (!p) {
              return;
            }
            p.selected = false;
            if (p.actions) {
              p.actions.map(a => a.selected = false)
            }
            if (!allNewPrivileges.some(priv => priv.id == p.id)) {
              allNewPrivileges.push(p)
            }

          })
          setSelectAll(allNewPrivileges)
          setAllPrivileges(data.content);
          newAllPrivilege = data.content;
          setLoading(false)
          if (props.type == "edits") {
            getCurrentPrivilege()
          }
        } else {
          setAlertOpen(false)
          setSeverity("error")
          setTopic("Error")
          setMessage(data.message)
          setLoading(true)
          setTimeout(() => {
            setAlertOpen(false)
          }, 6000)
        }
      })
  }
  //set All actions function
  const pushAllActions = (privileges, array) => {
    privileges.forEach((privilege) => {
      if (privilege && privilege.actions && Array.isArray(privilege.actions)) {
        privilege.actions.forEach((action) => {
          if (!array.includes(action.action_name)) {
            array.push(action.action_name);
          }
        });
        pushAllActions(privilege.child, array);
      } else {
      }
    });
  };


  let ids = []
  const idFinder = (privilege, allPrivileges) => {
    allPrivileges.map((p) => {
      if (p) {
        idFinder(privilege, p.child);
        if (privilege && privilege.id == p.id) {
          privilege.child.map(child => {
            ids.push(child)
            idFinder(child, privilege.child)
          })

        }
      }
    })
  }


  //select privilege
  const selectPrivileges = (privilege) => {
    idFinder(privilege, allPrivileges)
    findParent1(privilege, selectAll)
    let oldPrivileges = [...currentPrivileges]
    let parentIds = []
    parent1.map(p => {
      if (p) {
        if (!parentIds.some(item => item.id === p.id)) {
          parentIds.push(p);
        }
      }

    })
    let filterCurrentPrivilege = oldPrivileges.filter(p => p.id == privilege.id)

    if (filterCurrentPrivilege.length > 0) {
      parentIds.map((p, index) => {
        let parent = oldPrivileges.filter(priv => priv.id == p.id)
        console.log(parent[0])

        parentIds[index] = parent[0]

      })
      let currentPrivilegeIndex = oldPrivileges.findIndex(p => p.id == privilege.id)
      if (privilege.selected == false || privilege.selected == 'partial') {
        privilege.selected = true;

        if (privilege.actions) {
          privilege.actions.map(a => a.selected = true)
        }

        oldPrivileges[currentPrivilegeIndex] = privilege

        //select child
        ids.map(child => {
          if(child){
            child.selected = true;
            if (child.actions) {
              child.actions.map(action => {
                action.selected = true
              })
            }
            let findChildIndex = oldPrivileges.findIndex(p => p.id == child.id)

            if (findChildIndex != -1) {
              oldPrivileges[findChildIndex] = child
            } else {
              oldPrivileges.push(child)
            }
          }
        })

        //select parent
        parentIds.map(parent => {

          parent.child.map((child, index) => {
            if (oldPrivileges.some(p => p.id === child.id)) {
              let matchChildPrivilege = oldPrivileges.filter(p => p.id === child.id)
              parent.child[index] = matchChildPrivilege[0]
            }
          })
          const allChildSelect = parent.child.every(child => child.selected === true)
          const partialChildSelect = parent.child.some(child => child.selected === true)

          let parentIndex = oldPrivileges.findIndex(p => p.id === parent.id)
          if (allChildSelect) {
            if (parent.actions) {
              if (parent.actions.every(a => a.selected == true)) {
                parent.selected = true
                oldPrivileges[parentIndex] = parent
              } else {
                parent.selected = 'partial'
                oldPrivileges[parentIndex] = parent
              }
            } else {
              parent.selected = true
              oldPrivileges[parentIndex] = parent
            }

          } else if (partialChildSelect) {
            parent.selected = 'partial'
            oldPrivileges[parentIndex] = parent
          }

          if (parentIndex != -1) {
            oldPrivileges[parentIndex] = parent
          } else {
            oldPrivileges.push(parent)
          }

          // if(props.type === 'edits'){
          allPrivileges.map((p, index) => {
            if (parent.id == p.id) {
              allPrivileges[index] = parent
            }
          })
          // }
        })

      } else if (privilege.selected == true) {
        privilege.selected = false;
        setIsSelectAllPrivileges(false)
        if (privilege.actions) {
          privilege.actions.map(a => a.selected = false)
        }

        //remove privilege
        oldPrivileges = oldPrivileges.filter(p => !(privilege.id === p.id))


        ids.map(child => {
          if(child){
            child.selected = false;
            if (child.actions) {
              child.actions.map(action => action.selected = false)
            }
            oldPrivileges = oldPrivileges.filter(p => !(child.id === p.id))
          }
        })

        parentIds.map(parent => {
          let parentIndex = oldPrivileges.findIndex(p => p.id === parent.id)
          let parentPrivilege = oldPrivileges.filter(p => p.id == parent.id)[0]
          parentPrivilege.child.map((child, index) => {
            if (oldPrivileges.some(p => p.id === child.id)) {
              let matchChildPrivilege = oldPrivileges.filter(p => p.id === child.id)
              parentPrivilege.child[index] = matchChildPrivilege[0]
            }
          })
          const allParentUnSelect = parentPrivilege.child.every(child => child.selected === false);
          const partialChildSelect = parentPrivilege.child.some(child => child.selected === false || child.selected == 'partial')

          if (allParentUnSelect) {
            if (parentPrivilege.actions) {
              if (parentPrivilege.actions.every(a => a.selected == false)) {
                parentPrivilege.selected = false;
                oldPrivileges = oldPrivileges.filter(p => !(p.id === parentPrivilege.id))
              } else {
                parentPrivilege.selected = 'partial'
                oldPrivileges[parentIndex] = parentPrivilege
              }
            } else {
              parentPrivilege.selected = false;
              oldPrivileges = oldPrivileges.filter(p => !(p.id === parentPrivilege.id))
            }
          } else if (partialChildSelect) {
            parentPrivilege.selected = 'partial'
            // parent.actions = parentPrivilege.actions
            oldPrivileges[parentIndex] = parentPrivilege
          }

          // if(props.type === 'edits'){
          allPrivileges.map((p, index) => {
            if (parent.id == p.id) {
              allPrivileges[index] = parentPrivilege
            }
          })
          // }
        })

      }
    } else {
      privilege.selected = true
      if (privilege.actions) {
        privilege.actions.map(action => action.selected = true)
      }
      oldPrivileges.push(privilege)

      //select child privilege
      ids.map(child => {
        if(child){
          child.selected = true;
          if (child.actions) {
            child.actions.map(action => {
              action.selected = true
            })
          }
          let findChildIndex = oldPrivileges.findIndex(p => p.id == child.id)

          if (findChildIndex != -1) {
            oldPrivileges[findChildIndex] = child
          } else {
            oldPrivileges.push(child)
          }
        }
      })

      //set parent privilege as partial
      parentIds.map(parent => {
        if (oldPrivileges.filter(p => p.id == parent.id).length > 0) {
          let parentPrivilege = oldPrivileges.filter(p => p.id == parent.id)[0]
          parent = parentPrivilege
        }
        const allChildSelect = parent.child.every(child => child.selected === true)
        const partialChildSelect = parent.child.some(child => child.selected === true) || parent.child.some(child => child.selected === 'partial')

        let parentIndex = oldPrivileges.findIndex(p => p.id === parent.id)
        let filterPrivilege = oldPrivileges.filter(p => p.id == parent.id)
        let findAllFilter = allPrivileges.findIndex(p => p.id === parent.id)

        parent.child.map((child, index) => {
          if (oldPrivileges.some(p => p.id === child.id)) {
            let matchChildPrivilege = oldPrivileges.filter(p => p.id === child.id)
            parent.child[index] = matchChildPrivilege[0]
          } else {
            child.selected = false
          }
        })


        if (oldPrivileges.filter(p => p.id == parent.id).length == 0) {
          parent.child.map((child, index) => {
            if (oldPrivileges.filter(p => p.id == child.id).length > 0) {
            }
          })
          if (allChildSelect) {
            if (parent.actions) {
              if (parent.actions.every(a => a.selected == true)) {
                parent.selected = true
              } else {
                parent.selected = 'partial'
              }
            } else {

              parent.selected = true
            }

          } else if (partialChildSelect) {
            parent.selected = 'partial'
          } else {
            parent.selected = 'partial'
          }

          oldPrivileges.push(parent)

        } else {
          if (allChildSelect) {

            if (parent.actions) {
              if (parent.actions.every(a => a.selected == true)) {
                parent.selected = true
                oldPrivileges[parentIndex] = parent
                allPrivileges[findAllFilter] = parent
              } else {
                oldPrivileges[parentIndex] = parent
              }
              // allPrivileges[findAllFilter] = parents
            } else {

              parent.selected = true
              oldPrivileges[parentIndex] = parent
            }

          } else if (partialChildSelect) {
            parent.selected = 'partial'
            if (filterPrivilege.length > 0) {
              parent.actions = filterPrivilege[0].actions
            }
            oldPrivileges[parentIndex] = parent
          } else {
          }
        }
        if (props.type === 'edits') {
          allPrivileges.map((p, index) => {
            if (parent.id == p.id) {
              allPrivileges[index] = parent
            }
          })
        }
      })
    }
    setCurrentPrivileges(oldPrivileges);
  }

  let allPrivilegeIds = []
  const selectAllPrivileges = (allPrivileges) => {
    if (!isSelectAllPrivileges) {
      setIsSelectAllPrivileges(true)
      allPrivileges.map((privilege) => {
        if(privilege){ 
          privilege.selected = true
          if (privilege.actions) {
            privilege.actions.map(a => {
              a.selected = true
            })
          }
          if (!allPrivilegeIds.some(priv => priv.id == privilege.id)) {
            allPrivilegeIds.push(privilege)
          }

          selectAllPrivileges(privilege.child)
        }
      })
      setCurrentPrivileges(allPrivilegeIds)
    } else {
      setIsSelectAllPrivileges(false)
      currentPrivileges.map(p => {
        p.selected = false
        if (p.actions) {
          p.actions.map(a => a.selected = false)
        }
      })
      setCurrentPrivileges([])
    }
  }
  //Function to read pivilege name
  const readName = (e) => {
    const enteredValue = e.target.value;
    setSelectedName(enteredValue.trim());

    if (enteredValue.trim() === "") {
      setNameError({error: true, errorMsg: "Name is required"});
    } else {
      setNameError({error: false, errorMsg: ""});
    }
  }

  //Funcion to read new privilege id
  const readId = (e) => {
    if (props.type == "edits") {
      if (e.target.value === undefined || e.target.value === "") {
        setSelectedId(props.userRoleId)
      }
    }

    setSelectedId(e.target.value)
    if (e.target.value.trim() === "") {
      setIdError({error: true, errorMsg: "ID is required"});
    } else {
      setIdError({error: false, errorMsg: ""});
    }
  }
  //Function to read description
  const readDescription = (e) => {
    setSelectedDescription(e.target.value.trim())
  }

  //Submit data
  const submit = () => {
    const errors = [];

    const addError = (field, message) => {
      errors.push({field, message});
    };
    const data = {
      id: parseInt(selectedId),
      name: selectedName,
      description: selectedDescription,
      userPrivileges: currentPrivileges
    }
    let filterData = props.userRoles.filter(p => p.id === data.id)
    if (props.type === "edits") {

      if (filterData.length > 0 && data.id != props.userRoleId) {
        addError("id", "ID Already Exists")
      }
      if (data.name === undefined || data.name === "") {
        data.name = props.userName
      }
      if (Number.isNaN(data.id)) {
        data.id = props.userRoleId
      }
      if (Number.isNaN(data.id)) {
        console.log(data.id)
        addError("id", "ID Should Contain Only Numbers")
      }
      if (data.description === undefined || data.description === "") {
        data.description = props.description
      }
      // apiRequest(data, "PUT")
      // return
    }
    if (props.type === "new-role") {
      if (data.id === undefined) {
        addError("id", "Id is required");
      }
      if (filterData.length > 0 && data.id != props.userRoleId) {
        addError("id", "ID Already Exists")
      }
      if (Number.isNaN(data.id) && data.id !== undefined) {
        addError("id", "ID Should Contain Only Numbers")
      }

      if (data.name === undefined || data.name === "") {
        addError("name", "Name is required");
      }
    }

    if (errors.length > 0 || idError.error == true || nameError.error == true) {
      errors.forEach((error) => {
        const setError = error.field === "name" ? setNameError : setIdError;
        setError({error: true, errorMsg: error.message});
      });
      return;
    }

    // apiRequest(data, "POST")

    if (props.type === "new-role") {
      apiRequest(data, "POST");
    } else if (props.type === "edits") {
      apiRequest(data, "PUT");
    }
  }

  const apiRequest = (body, method) => {
    setLoading(true)
    let url = `${environment.host}/ums/super/user-role`
    if (method === "PUT") {
      url = url + "/" + props.userRoleId //When changing the id request parameter id should be the old id
    }
    fetch(url,
      {
        method: method,
        headers: {'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')},
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {

          setLoading(false)
          props.onClose()
          props.getUserRoles()
          props.setAlertOpen(true)
          props.setSeverity("success");
          props.setTopic("Success");
          if (method == "POST") {
            props.setMessage("Successfully Created User Rolei: " + body.name)

          } else if (method == "PUT") {
            props.setMessage("Succesfully Updated User Role: " + body.name)
          }

          setTimeout(() => {
            props.setAlertOpen(false)

          }, 5000)


        } else {
          props.setAlertOpen(true)
          props.setSeverity("error")
          props.setTopic("Error")
          props.setMessage(data.message)
          setLoading(false)
          setTimeout(() => {
            props.setAlertOpen(false)
          }, 6000)
        }
      })
  }

  useEffect(() => {
    getPrivileges()

  }, [])

  const getCurrentPrivilege = () => {
    fetch(`${environment.host}/ums/super/user-role/${props.userRoleId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
      }
    }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {
          let newCurrent = [];
          let current = data.content.userPrivileges.sort((a, b) => b.id - a.id);
          console.log("current privileges", current);
  
          //Add parent privileges to newCurrent
          current.forEach(p => {
            if (p.parentId === 'high-privilege' || p.parentId === null) {
              newCurrent.push(p);
            }
          });
  
          // Add child privileges
          current.forEach(p => {
            if (p.parentId !== 'high-privilege' && p.parentId !== null) {
              let parentIndex = newCurrent.findIndex(priv => priv.id === parseInt(p.parentId));
              if (parentIndex >= 0) {
                newCurrent.splice(parentIndex + 1, 0, p);
              } else {
                newCurrent.push(p);
              }
            }
          });
  
          // Handle the selection state for each privilege
          newCurrent.map((p, index) => {
            let allChildrenSelected = true;
            let hasPartialChildSelection = false;
  
            // Check if all child privileges are selected
            if (p.child && p.child.length > 0) {
              p.child.forEach(child => {
                if (child && child.selected !== true) {
                  allChildrenSelected = false;
                }
                if (child && child.selected === 'partial') {
                  hasPartialChildSelection = true;
                }
              });
            }
  
            let allActionsSelected = true;
            let hasPartialActionSelection = false;
  
            // Check if all actions are selected
            if (p.actions && p.actions.length > 0) {
              p.actions.forEach(action => {
                if (action.selected !== true) {
                  allActionsSelected = false;
                }
                if (action.selected === 'partial') {
                  hasPartialActionSelection = true;
                }
              });
            }
  
            // Set parent privilege selection state based on children and actions
            if (allChildrenSelected || allActionsSelected && !hasPartialChildSelection && !hasPartialActionSelection) {
              p.selected = true;
            } else if (hasPartialChildSelection || hasPartialActionSelection) {
              p.selected = 'partial';
            } else {
              p.selected = false;
            }
  
            newCurrent[index] = p;
          });
  
          setCurrentPrivileges(newCurrent);

          let newData = newAllPrivilege.map(p => {
            let matchedUserPrivilege = newCurrent.filter(cp => cp.id === p.id);
            if (matchedUserPrivilege.length > 0) {
              let matchActions;
              if (matchedUserPrivilege[0].actions) {
                matchActions = matchedUserPrivilege[0].actions.filter(action => {
                  return p.actions.some(pAction => pAction.action_name === action.action_name);
                });
              }
              matchedUserPrivilege[0].actions = matchActions;
              return matchedUserPrivilege[0];
            } else {
              p.selected = false;
              return p;
            }
          });
  
          setAllPrivileges(newData);
        } else {
          setAlertOpen(true);
          setSeverity("error");
          setTopic("Error");
          setMessage(data.message);
          setTimeout(() => {
            setAlertOpen(false);
          }, 6000);
        }
      });
  };
  



  //select privilege using actions
  const selectActionsFrom = (privilege, action) => {
    findParent1(privilege, selectAll)

    //get all parent
    let parentIds = []
    parent1.map(p => {

      if (p) {
        if (!parentIds.some(item => item.id === p.id)) {
          parentIds.push(p);
        }
      }

    })

    idFinder(privilege, allPrivileges)
    let oldCurrentPrivilege = [...currentPrivileges]
    //filter select privilege
    let filterPrivilege = oldCurrentPrivilege.filter(p => p.id === privilege.id);
    if (filterPrivilege.length > 0) {
      parentIds.map((p, index) => {
        let parent = oldCurrentPrivilege.filter(priv => priv.id == p.id)
        console.log(parent[0])

        parentIds[index] = parent[0]

      })
      console.log(parentIds)
      //current privilege index
      let selectPrivilegeIndex = oldCurrentPrivilege.findIndex(p => p.id === privilege.id);

      if (action.selected == false || action.selected == null) {
        action.selected = true
        let actionIndex = privilege.actions.findIndex(a => a.action_name == action.action_name)
        privilege.actions[actionIndex] = action

        if (privilege.actions) {

        }
        if (privilege.actions.every(a => a.selected == true)) {
          if (privilege.child.length == 0) {
            privilege.selected = true
          } else {
            if (privilege.child.every(pri => pri.selected == true)) {
              privilege.selected = true
            } else {
              privilege.selected = 'partial'
            }
          }
          oldCurrentPrivilege[selectPrivilegeIndex] = privilege
        } else if (privilege.actions.some(a => a.selected == true)) {
          privilege.selected = 'partial'
          oldCurrentPrivilege[selectPrivilegeIndex] = privilege
        }

        //parent select and unselect
        parentIds.map(parent => {

          parent.child.map((child, index) => {
            if (oldCurrentPrivilege.some(p => p.id === child.id)) {
              let matchChildPrivilege = oldCurrentPrivilege.filter(p => p.id === child.id)
              parent.child[index] = matchChildPrivilege[0]
            }
          })
          let parentIndex = oldCurrentPrivilege.findIndex(p => p.id == parent.id)
          const allParentUnSelect = parent.child.every(child => child.selected === true);
          const partialChildSelect = parent.child.some(child => child.selected === true)

          if (allParentUnSelect) {
            if (parent.actions) {
              if (parent.actions.every(a => a.selected == true)) {
                parent.selected = true
                oldCurrentPrivilege[parentIndex] = parent
              } else {
                parent.selected = 'partial'
                oldCurrentPrivilege[parentIndex] = parent
              }
            } else {
              parent.selected = true
              oldCurrentPrivilege[parentIndex] = parent
            }

          } else if (partialChildSelect) {
            parent.selected = 'partial'
            oldCurrentPrivilege[parentIndex] = parent
          }
        })
      } else if (action.selected == true) {
        action.selected = false
        setIsSelectAllPrivileges(false)
        let actionIndex = privilege.actions.findIndex(a => a.action_name == action.action_name)
        privilege.actions[actionIndex] = action

        if (privilege.actions) {
          if (privilege.actions.every(a => a.selected == false)) {
            if (privilege.child.length == 0) {
              privilege.selected = false
              oldCurrentPrivilege = oldCurrentPrivilege.filter(p => !(p.id == privilege.id))
            } else {
              if (privilege.child.every(child => child.selected == false)) {
                privilege.selected = false
                oldCurrentPrivilege = oldCurrentPrivilege.filter(p => !(p.id == privilege.id))
              } else {
                privilege.selected = 'partial'
                oldCurrentPrivilege[selectPrivilegeIndex] = privilege
              }
            }

          } else if (privilege.actions.some(a => a.selected == false)) {
            privilege.selected = 'partial'
            oldCurrentPrivilege[selectPrivilegeIndex] = privilege
          }
        }

        //parent select and unselect
        parentIds.map(parent => {

          parent.child.map((child, index) => {
            if (oldCurrentPrivilege.some(p => p.id === child.id)) {
              let matchChildPrivilege = oldCurrentPrivilege.filter(p => p.id === child.id)
              parent.child[index] = matchChildPrivilege[0]
            }
          })
          let parentIndex = oldCurrentPrivilege.findIndex(p => p.id == parent.id)
          const allParentUnSelect = parent.child.every(child => child.selected === false);
          const partialChildSelect = parent.child.some(child => child.selected === false) || parent.child.some(child => child.selected == 'partial')
          let parentMatch = allPrivileges.findIndex(p => p.id == parent.id)
          if (allParentUnSelect) {
            if (parent.actions) {
              if (parent.actions.every(a => a.selected == false)) {
                parent.selected = false;
                oldCurrentPrivilege = oldCurrentPrivilege.filter(p => !(p.id == parent.id))
                allPrivileges[parentMatch] = parent

              } else {
                parent.selected = 'partial'
                oldCurrentPrivilege[parentIndex] = parent
              }
            } else {
              parent.selected = false;
              oldCurrentPrivilege = oldCurrentPrivilege.filter(p => !(p.id == parent.id))
              allPrivileges[parentMatch] = parent
            }
          } else if (partialChildSelect) {
            parent.selected = 'partial'
            oldCurrentPrivilege[parentIndex] = parent
          }
        })
      }

    } else {
      action.selected = true
      let actionIndex = privilege.actions.findIndex(a => a.action_name == action.action_name)

      privilege.actions[actionIndex] = action

      if (privilege.actions) {
        if (privilege.actions.every(a => a.selected == true) && privilege.child.length == 0) {
          privilege.selected = true
        } else if (privilege.actions.some(a => a.selected == true)) {
          privilege.selected = 'partial'
        }
      }

      oldCurrentPrivilege.push(privilege)

      //parent select
      parentIds.map(parent => {
        if (oldCurrentPrivilege.filter(p => p.id == parent.id).length > 0) {
          let parentPrivilege = oldCurrentPrivilege.filter(p => p.id == parent.id)[0]
          parent = parentPrivilege
        }
        if (oldCurrentPrivilege.filter(p => p.id == parent.id).length > 0) {
          parent.child.map((child, index) => {
            if (oldCurrentPrivilege.some(p => p.id === child.id)) {
              let matchChildPrivilege = oldCurrentPrivilege.filter(p => p.id === child.id)
              parent.child[index] = matchChildPrivilege[0]
            }
          })
          let parentIndex = oldCurrentPrivilege.findIndex(p => p.id == parent.id)
          let filterParent = oldCurrentPrivilege.filter(p => p.id == parent.id)
          const allParentUnSelect = parent.child.every(child => child.selected === true);
          const partialChildSelect = parent.child.some(child => child.selected === true)


          if (allParentUnSelect) {
            if (parent.actions) {
              if (parent.actions.every(a => a.selected == true)) {
                parent.selected = true
              } else {
                parent.selected = 'partial'
              }
            } else {
              parent.selected = true
            }
            oldCurrentPrivilege[parentIndex] = parent
          } else if (partialChildSelect) {
            parent.selected = 'partial'
            oldCurrentPrivilege[parentIndex] = parent

          }
        } else {
          parent.selected = 'partial'
          oldCurrentPrivilege.push(parent)
        }
        if (props.type === 'edits') {
          allPrivileges.map((p, index) => {
            if (parent.id == p.id) {
              allPrivileges[index] = parent
            }
          })
        }
      })
    }
    setCurrentPrivileges(oldCurrentPrivilege)

  }

  let parent1 = [];
  const findParent1 = (privilege, allPrivileges) => {

    let filtered = allPrivileges.filter(p => p.id === parseInt(privilege.parentId));
    filtered.forEach(p => parent1.push(p));

    if (filtered.length > 0 && filtered[0].parentId !== "high-privilege") {
      let grandParent = findParent1(filtered[0], allPrivileges);
      parent1.push(grandParent);
    }
    setParentSelect(parent1);
  }


  return (
    <div>
      <Grid container style={{textAlign: "left"}}>
        <Grid item style={{textAlign: "right"}}>
          <IconButton onClick={() => props.onClose()}>
            <BackIcon/>
          </IconButton>
        </Grid>
        <Grid item xs={5} md={5} style={{textAlign: "left", marginTop: "12px"}}>
          <Typography className={classes.addNew}>{props.type === "edits" ? "Update Role" : "Add New Role"}</Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <Paper className={classes.paperContainer}>
            <Grid container>
              <Grid item xs={12} md={4} style={{padding: "15px"}}>
                <Typography className={classes.text}>Enter ID</Typography>
                <TextBar onChange={(e) => readId(e)} defaultValue={props.userRoleId} type="text" error={idError}
                         width="95%" disabled={props.type == 'edits'}/>
              </Grid>
              <Grid item xs={12} md={4} style={{padding: "15px"}}>
                <Typography className={classes.text}>Enter Role Name</Typography>
                <TextBar onChange={(e) => readName(e)} defaultValue={props.userName} type="text" error={nameError}
                         width="95%"/>
              </Grid>
              <Grid item xs={12} md={4} style={{padding: "15px"}}>
                <Typography className={classes.text}>Enter Description</Typography>
                <TextBar onChange={(e) => readDescription(e)} defaultValue={props.description} type="text"
                         error={{error: false}} width="100%"/>
              </Grid>
              <CustomAccordion expanded={hidden} elevation={0} TransitionProps={{unmountOnExit: true}}
                               className={classes.highPrivilegeAccording} style={{backgroundColor: '#fff'}}>
                <AccordionSummary style={{height: "70px", display: "flex", justifyContent: "center"}}
                                  expandIcon={<ExpandMoreIcon/>} onClick={() => setHidden(!hidden)}>
                  <Grid item xs={1} md={2}>
                    <Typography className={classes.text}>Privileges</Typography>
                  </Grid>
                  <Grid item md={10} style={{paddingTop: '15px'}}>
                    <Divider/>
                  </Grid>
                </AccordionSummary>
              </CustomAccordion>

              {
                hidden === false ?
                  <>
                    <Grid item xs={12} md={4} style={{padding: "16px"}}>
                      <SearchBar onChange={(e) => setSearch(e.target.value)}/>
                    </Grid>

                    <Grid container className={classes.tableHeader}>
                      <Grid item xs={6} md={4} style={{textAlign: "center"}}>
                        <Typography style={{fontWeight: "bold"}}>PRIVILEGES</Typography>
                      </Grid>
                      <Grid item xs={6} md={8} style={{textAlign: "center"}}>
                        <Typography style={{fontWeight: "bold"}}>ACTIONS</Typography>
                      </Grid>
                    </Grid>
                    <Grid container style={{marginTop: "10px", marginBottom: "10px"}}>
                      <Grid item xs={9} md={9}></Grid>
                      <Grid item xs={3} md={3} style={{
                        textAlign: "right",
                        paddingRight: "16px",
                        border: 'solid 1px',
                        color: "#000000BF",
                        borderRadius: '5px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignContent: 'center'
                      }}
                            onClick={() => selectAllPrivileges(allPrivileges)}>
                        <Checkbox style={{color: "rgba(24, 29, 51,0.63)"}}
                                  checked={currentPrivileges.length == selectAll.length && currentPrivileges.every(p => p.selected == true) ? true : false}
                        />
                        <Button variant="outlined"
                                style={{
                                  color: "#000000BF",
                                  border: 'none'
                                }}>{currentPrivileges.length == selectAll.length && currentPrivileges.every(p => p.selected == true) ? 'Unselect All' : 'Select All'}</Button>

                      </Grid>
                    </Grid>

                    <Grid container style={{marginBottom: "16px"}}>
                      {
                        allPrivileges.filter((obj) => {
                          if (search === "") {
                            return obj
                          } else if (obj.name.toLowerCase().includes(search.trim().toLowerCase())) {
                            return obj
                          }
                        }).map((privilege, index) => {
                          return (
                            <CustomAccordion key={index} expanded={index == show} elevation={0}
                                             TransitionProps={{unmountOnExit: true}}
                                             className={classes.highPrivilegeAccording}>
                              <AccordionSummary
                                style={{height: "70px", paddingRight: privilege.child.length == 0 ? '30px' : '0px'}}
                                expandIcon={privilege.child.length > 0 ? <ExpandMoreIcon/> : <></>} onClick={() => {
                                openEdit(index)
                              }}>
                                <Grid container>
                                  <Grid item xs={1} md={1} style={{display: "flex", alignItems: "center"}}>
                                    <Checkbox style={{color: "rgba(24, 29, 51,0.63)"}}
                                              onChange={() => selectPrivileges(privilege)}
                                              checked={privilege.selected == true}
                                              onClick={(e) => e.stopPropagation()}
                                              indeterminate={(privilege.selected == 'partial')}/>
                                  </Grid>
                                  <Grid item xs={3} md={3} style={{display: "flex", alignItems: "center"}}>
                                    <Tooltip title={privilege.name} placement="bottom-start" arrow>
                                      <Typography
                                        style={{textTransform: 'capitalize'}}>{privilege.name.length > 10 ? (privilege.name.substring(0, 10) + "...").replace("_", " ") : privilege.name.replace("_", " ")}</Typography>
                                    </Tooltip>
                                  </Grid>
                                  <Grid key={index} item md={8} xs={8} style={{display: 'flex', overflowX: 'auto'}}>
                                    {privilege.actions ?
                                      privilege.actions.map((action, actionIndex) => {
                                        return <Grid key={actionIndex} item md={8} xs={8} style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                                          marginRight: '10px'
                                        }}>
                                          <Checkbox style={{color: "rgba(24, 29, 51,0.63)"}}
                                                    checked={action.selected == true}
                                                    onChange={() => {
                                                      selectActionsFrom(privilege, action)
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                    indeterminate={(privilege.selected == 'partial')}/>
                                          <Grid
                                            style={{fontFamily: 'Roboto, Helvetica, Arial, sans-serif'}}>{action.action_name}</Grid>
                                        </Grid>
                                      }) : <></>

                                    }
                                  </Grid>
                                </Grid>
                              </AccordionSummary>
                              <AccordionDetails
                                style={{backgroundColor: "white", paddingBottom: "0px", padding: "0px"}}>
                                <AddNewRoleAccordingList allActions={allActions}
                                                         onChange={(privilege) => selectPrivileges(privilege)}
                                                         data={privilege.child} opacity={0.25} padding={1}
                                                         currentPrivileges={currentPrivileges}
                                                         selectActionsFrom={(privilege, action) => selectActionsFrom(privilege, action)}/>
                              </AccordionDetails>
                            </CustomAccordion>
                          )
                        })
                      }

                    </Grid>
                  </>
                  : <div></div>
              }
              <Grid item md={9} xs={9}></Grid>
              <Grid item xs={3} md={1} style={{marginTop: "30px"}}>
                <Button variant='contained' className={classes.cancel} onClick={props.onClose}>Cancel</Button>
              </Grid>
              <Grid item xs={3} md={2}
                    style={{marginTop: "30px", paddingRight: "16px", display: 'flex', justifyContent: 'flex-end'}}>
                <Button variant='contained' className={classes.add}
                        onClick={submit}>{props.type === "edits" ? "Update" : "Add"}</Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <AlertBar open={alertOpen} severity={severity} topic={topic} message={message}/>
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80}/>
        </div>
      }
    </div>
  )
}

const CustomAccordion = withStyles({
  root: {
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(Accordion);

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    addNew: {
      fontWeight: "bold"
    },
    paperContainer: {
      width: "100%",
      boxShadow: "none",
      marginTop: "16px",
      marginBottom: "10px"
    },
    text: {
      color: "#707070",
      paddingBottom: "10px"
    },
    tableHeader: {
      backgroundColor: "#EFF6FF",
      color: "black",
      marginTop: "15px",
      paddingTop: "10px",
      paddingBottom: "10px"
    },
    actionsBar: {
      paddingTop: "5px",
      paddingBottom: "5px",
    },
    highPrivilegeAccording: {
      backgroundColor: mainAccordingColor,
      width: "100%",
      marginBottom: "1px",
    },
    iconBackground: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      backgroundColor: "white"
    },
    add: {
      backgroundColor: addButtonColor,
      color: "white",
      marginBottom: "10px",
      marginRight: "10px",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    cancel: {
      backgroundColor: "white",
      color: "#707070",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    }
  }),
);

const BackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
    </svg>
  )
}
const ExpandIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#91949E">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
    </svg>
  )
}

const ExpandMoreIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
    </svg>
  )
}

const Selected = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#00CF37">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
    </svg>
  )
}

const NotSelected = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="red">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
  )
}
